// js/sections/Hero-section-with-bubbles.js
class BubblesContainer extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.render();
    }
  
    render() {
      const categoryBubbles = Array.from(this.querySelectorAll('.bubble'));
      const groupedBlocks = groupBlocksByCategory(categoryBubbles);
      if (groupedBlocks.length <= 1) {
        return;
      }
  
      const tabHeader = document.createElement('div');
      tabHeader.classList.add('tab-header');
  
      groupedBlocks.forEach((category) => {
        const tabItem = document.createElement('div');
        tabItem.classList.add('tab-item');
        tabItem.textContent = category;
        tabItem.addEventListener('click', () => {
          this.toggleVisibility(category);
        });
        tabHeader.appendChild(tabItem);
      });
  
      this.prepend(tabHeader);
      this.toggleVisibility(groupedBlocks[0])
    }
  
    toggleVisibility(category) {
        const bubbles = Array.from(this.querySelectorAll('.bubble'));
        bubbles.forEach((bubble) => {
            if (bubble.dataset.category === category) {
                bubble.style.display = 'block';
            }
            else{
                bubble.style.display = 'none';
            }
        });

        const tabItems = Array.from(this.querySelectorAll('.tab-item'));
        tabItems.forEach((tabItem) => {
          if (tabItem.textContent === category) {
            tabItem.classList.add('active');
          } else {
            tabItem.classList.remove('active');
          }
        });
        document.dispatchEvent(new CustomEvent('slide-category:update', { detail: { category } }));
    }
  }
  
  function groupBlocksByCategory(blocks) {
    const categories = new Set(blocks.map((block) => block.dataset.category));
    return Array.from(categories);
  }
  
customElements.define('bubbles-container', BubblesContainer);



 // js/sections/featured-collection-list.js 
 class FeaturedCollectionList extends HTMLElement {
  constructor() {
    super();
    this.categoryBubbles = null;
    this.tabItems = [];
  }

  connectedCallback() {
    this.render();
  }

  render(){
    const collections = Array.from(this.querySelectorAll('.products-category'));
      if(collections.length>0){
      this.tabItems = Array.from(this.querySelectorAll('.tab-collection'));

      this.tabItems.forEach((tabItem) => {
        tabItem.addEventListener('click', () => {
          const selectedCategory = tabItem.dataset.category;
          this.showCollectionByCategory(selectedCategory);
        });
      });
      this.showCollectionByCategory(collections[0].dataset.category)
    }
  }

  showCollectionByCategory(category) {
    const collections = Array.from(this.querySelectorAll('.products-category'));
        collections.forEach((collection) => {
            if (collection.dataset.category === category) {
              collection.style.display = 'grid';
            }
            else{
              collection.style.display = 'none';
            }
        });

        const tabItems = Array.from(this.querySelectorAll('.tab-collection'));
        tabItems.forEach((tabItem) => {
          if (tabItem.dataset.category === category) {
            tabItem.classList.add('active');
          } else {
            tabItem.classList.remove('active');
          }
        });
  }

}
customElements.define('featured-collection-list', FeaturedCollectionList);




// js/sections/top-bar-filters.js
class TopBarFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.available_filters=this.dataset.filtersAvailable.split(',');
    this.active_filters=this.dataset.filtersActive.split(',');
    this.render();
  }

  render() {
    const categoryFilters = Array.from(this.querySelectorAll('.buttons-to-check'));
    categoryFilters.forEach((category) =>{
      let availability=this.checkAvailability(category);
      switch (availability) {
        case 'available':
          category.addEventListener("click", (event)=> {
            this.handleFilter(category.dataset.forTag);
          });
          break;
        case 'active':
          category.classList.add('Active_filter');
          category.addEventListener("click", (event)=> {
            this.handleFilter(category.dataset.forTag);
          });
          break;
        case 'notallowed':
          category.disabled=true;
          break;
      }
    })

    //check for all filters and all handle to click
    let productCard = document.querySelectorAll('product-card');
    if(this.active_filters.length==1 || productCard.length == 0){
      this.querySelector('#label-for-all').classList.add('Active_filter');
    }
    this.querySelector('#label-for-all').addEventListener("click", (event)=> {
      // Get the reset button
      const label = document.querySelector("a.facet-clear-all");
      // If the label element is found, trigger a click event on it
      if (label) {
        label.click();
      }
    });
  }

  handleFilter(category) {
    const inputElements = document.querySelectorAll('input[name="filter.p.tag"]');
    inputElements.forEach(function(element){
        if(element.value.toLowerCase().replaceAll(/\s/g,'')==category.toLowerCase().replaceAll(/\s/g,'')){
            element.click();
            return
        }
    })
  }

  checkAvailability(category) {
    let foundValueActive = this.active_filters.find(function(element) {
      return element.toLowerCase().replaceAll(/\s/g,'') === category.dataset.forTag.toLowerCase().replaceAll(/\s/g,'');
    });

    let foundValueAvailable = this.available_filters.find(function(element) {
      return element.toLowerCase().replaceAll(/\s/g,'') === category.dataset.forTag.toLowerCase().replaceAll(/\s/g,'');
    });
    if(foundValueActive){
      return "active"
    }
    else if (foundValueAvailable){
      return "available"
    }
    else {
      return "notallowed"
    }
  }
}

customElements.define('top-bar-filters', TopBarFilters);

import {fetchCart} from "//xendurance.com/cdn/shop/t/110/assets/theme.js?v=77593443599691078301781294311";
class MainProduct extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  async render() {
    const cartContent = await fetchCart; // JSON cart content
    cartContent?.items.forEach(item => {
      if(item.id==40692118094012){
        this.querySelector('.product').classList.add('cart-has-membership')
      }
    });
  }
}

customElements.define('main-product', MainProduct);


//override productForm
import {ProductForm} from "//xendurance.com/cdn/shop/t/110/assets/theme.js?v=77593443599691078301781294311"; // Import the theme web component

class customProductForm extends ProductForm {
  async _onSubmit(event) {
    event.preventDefault();
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }
    const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    const formData = new FormData(this);
    formData.set("sections", sectionsToBundle.join(","));
    const skioSellingPlanInput = document.querySelector('.product-info input[name="selling_plan"]');
    formData.set("selling_plan", skioSellingPlanInput?.value)

    /*
     * Skio "Become a Member"
     * When the Skio plan picker's "Become a Member" option is selected, add the
     * main product as a one-time purchase plus the membership product on its
     * subscription. The membership variant/selling-plan are driven by the Skio
     * plan picker block settings (resolved in Liquid, exposed as data attributes).
     */
    if (skioSellingPlanInput?.getAttribute('data-skio-membership-selected') === 'true') {
      const membershipVariantId = skioSellingPlanInput.getAttribute('data-skio-membership-variant-id');
      const membershipSellingPlanId = skioSellingPlanInput.getAttribute('data-skio-membership-selling-plan-id');

      // Main product is added one-time.
      formData.set("selling_plan", "");

      if (membershipVariantId) {
        const formDataMemberShip = new FormData();
        formDataMemberShip.append('id', membershipVariantId);
        formDataMemberShip.append('quantity', 1);
        if (membershipSellingPlanId) {
          formDataMemberShip.append('selling_plan', membershipSellingPlanId);
        }
        await fetch(`${Shopify.routes.root}cart/add.js`, {
          body: formDataMemberShip,
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest"
            // Needed for Shopify to check inventory
          }
        });
      }
    }

    formData.set("sections_url", `${Shopify.routes.root}variants/${this.id.value}`);
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
        // Needed for Shopify to check inventory
      }
    });
    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });
    const responseJson = await response.json();
    if (response.ok) {
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));
      setTimeout(() => {
          FGSECOMAPP.renderPromotionMessage(FGSECOMAPP.offers);
      }, 500)
    } else {
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
    }
  }
}

// Create the custom elements
if (!window.customElements.get("custom-product-form")) {
  window.customElements.define("custom-product-form", customProductForm, { extends: "form" });
}



class quickProductForm extends ProductForm {
  async _onSubmit(event) {
  event.preventDefault();
  //delete smarter div
  debugger
  this.querySelector('input[data-smartrr-widget-selling-plan-input]')?.remove();
    if (!this.checkValidity()) {
      this.reportValidity();
      return;
    }
    const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
    submitButtons.forEach((submitButton) => {
      submitButton.setAttribute("disabled", "disabled");
      submitButton.setAttribute("aria-busy", "true");
    });
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    const formData = new FormData(this);
    formData.set("sections", sectionsToBundle.join(","));
    formData.set("sections_url", `${Shopify.routes.root}variants/${this.id.value}`);
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: formData,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest"
        // Needed for Shopify to check inventory
      }
    });
    submitButtons.forEach((submitButton) => {
      submitButton.removeAttribute("disabled");
      submitButton.removeAttribute("aria-busy");
    });
    const responseJson = await response.json();
    if (response.ok) {
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));
    } else {
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"]
        }
      }));
    }
  }

}


// Create the custom elements
if (!window.customElements.get("quick-product-form")) {
  window.customElements.define("quick-product-form", quickProductForm, { extends: "form" });
}


class KlaviyoFormComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('.form-klaviyo-newsletter');
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(event) {
    event.preventDefault();
    // Add any additional logic or validation here
    const emailInput = this.form.querySelector('input[name="contact[email]"]').value;

    const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=VQ9yJa';

    const data = {
      data: {
        type: "subscription",
        attributes: {
          list_id: "XQXPxW",
          email: emailInput,
        }
      }
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Revision': '2023-06-15'
      },
      body: JSON.stringify(data)
    })
      .then(data => {
        if(data.ok){
          this.querySelector('form-klaviyo-newsletter .form_on_success').style.display = "block";
          this.querySelector('form-klaviyo-newsletter .fieldset-with-submit').style.display = "none";
        }
        else{
          this.querySelector('form-klaviyo-newsletter .form_on_danger').style.display = "block";
          const submitButton = this.form.querySelector('button[type="submit"]');
          submitButton.setAttribute('aria-busy', 'false');

        }
      })
      .catch(errors => {
        this.querySelector('form-klaviyo-newsletter .form_on_danger').style.display = "block";
        const submitButton = this.form.querySelector('button[type="submit"]');
        submitButton.setAttribute('aria-busy', 'false');
      });
  }
}

customElements.define('form-klaviyo-newsletter', KlaviyoFormComponent);
class FeaturedChartCustomized extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    //calculate the width
    const calculateWidth = () => {
      if (window.innerWidth < 700) {
        // Select the table within the web component
        const table = this.querySelector('.feature-table');
  
        // Get the computed width of the table
        const tableWidth = getComputedStyle(table).width;
  
        const secondTd = this.querySelector('tbody td:nth-child(2)');
        const secondTdWidth = getComputedStyle(secondTd).width;
  
        // Calculate the width for the first <td> in <thead>
        const tdWidth = `calc(${tableWidth} - ${secondTdWidth})`;
  
        // Set the width for the first <td> in <thead>
        const firstTd = this.querySelector('thead td');
        firstTd.style.minWidth = tdWidth;
        firstTd.style.maxWidth = tdWidth;
      }
    }
    calculateWidth();
    window.addEventListener('resize', calculateWidth);

    //add bullet checked
    const table = this.querySelector('.feature-table');
    const firstBullet = this.querySelector('.bullet-pagination li:first-child');
    const secondBullet = this.querySelector('.bullet-pagination li:last-child');


    firstBullet.addEventListener('click', () => {
      table.scrollLeft = 0; // Scroll to the beginning of the scrollbar
      setActiveBullet(firstBullet,secondBullet)
    });

    secondBullet.addEventListener('click', () => {
      table.scrollLeft = table.scrollWidth - table.clientWidth; // Scroll to the end of the scrollbar
      setActiveBullet(secondBullet,firstBullet)
    });


    table.addEventListener('scroll', () => {
      setActiveBulletBasedOnScroll(table, firstBullet, secondBullet);
    });

    //trigger click on the first button
    setActiveBulletBasedOnScroll(table, firstBullet, secondBullet);

    
  }
}
function setActiveBullet(activeBullet, inactiveBullet) {
  activeBullet.classList.add('active-bull');
  inactiveBullet.classList.remove('active-bull');
}

function setActiveBulletBasedOnScroll(table, firstBullet, secondBullet) {
  const scrollLeft = table.scrollLeft;

  if (scrollLeft === 0) {
    setActiveBullet(firstBullet, secondBullet);
  } else if (Math.floor(scrollLeft) >= Math.floor(table.scrollWidth - table.clientWidth - 5 )) {
    setActiveBullet(secondBullet, firstBullet);
  }
}
customElements.define('feature-chart-customized', FeaturedChartCustomized);


class SwiperComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
    
    // Listen for window resize events
    window.addEventListener('resize', () => this.handleResize());
  }

  initSwiper() {
    // Configure Swiper with the retrieved options
    const swiperOptions = {
      slidesPerView: 3,
      spaceBetween: 30,
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      //   dynamicBullets: true,
      //   dynamicMainBullets: 5
      // },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    };

    // Check screen width and initialize Swiper accordingly
    this.mySwiper = window.innerWidth > 1000 ? new Swiper(this, swiperOptions) : null;
  }

  handleResize() {
    // Check screen width and initialize/destroy Swiper accordingly
    if (window.innerWidth > 1000 && !this.mySwiper) {
      this.initSwiper();
    } else if (window.innerWidth <= 1000 && this.mySwiper) {
      this.destroySwiper();
    }
  }

  destroySwiper() {
    if (this.mySwiper) {
      this.mySwiper.destroy();
      this.mySwiper = null;
    }
  }
}

customElements.define("swiper-component", SwiperComponent);